function getPercentLegend( perType, value ) {
  const total = Object.values( perType ).reduce( ( acc, curr ) => acc + curr )
  
  return Number( ( value / total ) * 100 ).toFixed()
}

export default getPercentLegend
